export default __webpack_public_path__ + "static/media/Advanced Potion Making - Final_22.f860893a.jpg";